module.exports = __webpack_public_path__ + "static/media/esperanto.06288070.svg";